import * as React from "react";

import { UitkSpacing } from "uitk-react-spacing";

import { CampaignRecommendationsWithOffersQuery } from "../../../../../../__generated__/api";
import Campaign = CampaignRecommendationsWithOffersQuery.Campaigns;

export interface CampaignDescriptionProps {
  campaign: Campaign;
  isCentered: boolean;
  isHavingOriginCity?: string | null;
  showDescription: boolean;
}

export const CampaignDescription: React.FC<CampaignDescriptionProps> = ({
  campaign,
  isCentered,
  isHavingOriginCity,
  showDescription,
}) => {
  if (!showDescription) {
    return null;
  }

  const { description, fromOriginHeaderText } = campaign;

  return (
    <>
      {description.long && (
        <UitkSpacing margin={{ inlineend: "one" }}>
          <span className={isCentered ? "uitk-type-paragraph-400" : "uitk-type-paragraph-300"}>{description.long}</span>
        </UitkSpacing>
      )}
      {isHavingOriginCity && (
        <UitkSpacing margin={{ inlineend: isCentered ? undefined : "one" }}>
          <span className={isCentered ? "uitk-type-paragraph-400" : "uitk-type-paragraph-300"}>
            {`${fromOriginHeaderText}.`}
          </span>
        </UitkSpacing>
      )}
    </>
  );
};
